import React from "react";
import O3Wallet from "../assests/images/03wallet.jpeg";
import OneInch from "../assests/images/1inch.jpeg";
import Aktionariat from "../assests/images/aktionary.jpeg";
import Alice from "../assests/images/alice.jpeg";
import Argent from "../assests/images/argent.jpg";
import AtWallet from "../assests/images/at.wallet.jpeg";
import Atoken from "../assests/images/atoken.jpeg";
import Atomic from "../assests/images/atomic.jpeg";
import Authereum from "../assests/images/authereum.jpeg";
import BitKeep from "../assests/images/bitkeep.jpeg";
import Bitpay from "../assests/images/bitpay.jpeg";
import Coin98 from "../assests/images/coin98.jpeg";
import Coinomi from "../assests/images/coinomi.jpeg";
import CoolWallet from "../assests/images/coolwallet.jpeg";
// import Gnosis from "../assests/images/gnosis-safe.jpg";
import CriptoCom from "../assests/images/cripto-com.jpeg";
import Cybavo from "../assests/images/cybavo.jpeg";
// import Alpha from "../assests/images/alphawallet.jpeg";
import Dcent from "../assests/images/d'cent.jpeg";
import Dharma from "../assests/images/ddharma.jpeg";
import Defiant from "../assests/images/defiant.jpeg";
import Dok from "../assests/images/dok.jpeg";
import EasyPocket from "../assests/images/easypocket.jpeg";
import Eidor from "../assests/images/eidoo.jpeg";
import Ellipal from "../assests/images/eliipa.jpeg";
import Flare from "../assests/images/flare.jpeg";
import GridPlus from "../assests/images/gridplus.jpeg";
import Guarda from "../assests/images/guarda.jpeg";
import HaloDefi from "../assests/images/halodefi.jpeg";
import HashKey from "../assests/images/hashkey-me.jpeg";
import Huobi from "../assests/images/huobi.jpeg";
import ImToken from "../assests/images/im-token.jpeg";
import Infinito from "../assests/images/infinito.jpeg";
import Infinity from "../assests/images/infinty-wallet.jpeg";
import Jade from "../assests/images/jade.jpeg";
import KeyRing from "../assests/images/keyring.jpeg";
import KyberSwap from "../assests/images/kyber.jpeg";
import LedgerLive from "../assests/images/ledger-live.jpeg";
import Loopring from "../assests/images/loopring.jpeg";
// import TokenWallet from "../assests/images/tokenpocket.jpeg";
import mathwallet from "../assests/images/mathwallet.jpeg";
import MetaMask from "../assests/images/metamask.jpeg";
import Midas from "../assests/images/midas.jpeg";
import Mykey from "../assests/images/mykey.jpeg";
import Nash from "../assests/images/nash.jpeg";
import Onto from "../assests/images/onto.jpeg";
import Ownbit from "../assests/images/ownbit.jpeg";
import PeakDefi from "../assests/images/peakdefi.jpeg";
import Pillar from "../assests/images/pillar.jpeg";
import PlasmaPay from "../assests/images/plasmapay.jpeg";
import Rainbow from "../assests/images/rainbow.png";
import RWallet from "../assests/images/rwallet.jpeg";
import SafePal from "../assests/images/safepal.jpeg";
import Spatium from "../assests/images/spatium.jpeg";
import Talken from "../assests/images/talken.jpeg";
import Tokenary from "../assests/images/tokenary.jpeg";
import Tongue from "../assests/images/tongue.jpeg";
import Torus from "../assests/images/torus.jpeg";
import TrustWallet from "../assests/images/trust-wallet.png";
import Trustee from "../assests/images/trustee.jpeg";
import TrustVault from "../assests/images/trustvault.jpeg";
import Unstoppable from "../assests/images/unstopable.jpeg";
// import BridgWallet from "../assests/images/bridge-wallet.jpeg";
// import SparkPoint from "../assests/images/SparkPoint";
import ViaWallet from "../assests/images/viawallet.jpeg";
import Vision from "../assests/images/vision.jpeg";
import WalletIo from "../assests/images/wallet.io.jpeg";
import Walleth from "../assests/images/walleth.jpeg";
import XinfinXdc from "../assests/images/xinfin-xdc.jpeg";
import Zelcore from "../assests/images/zelcore.jpeg";
// import { ElrModal } from "./Modal";
import AlphaWallet from "../assests/newfile/alphawallet.jpg";
import BalletWallet from "../assests/newfile/balletwallet.jpg";
import BeeWallet from "../assests/newfile/beewallet.png";
import Bitski from "../assests/newfile/bitski.png";
import BridgeWallet from "../assests/newfile/bridge-wallet.jpg";
import OtherApp from "../assests/newfile/btcimg.jpg";
import Cosmotation from "../assests/newfile/cosmotation.png";
import CryptnosApp from "../assests/newfile/cryptnoxapp.png";
import FilWallet from "../assests/newfile/filwallet.png";
import Frontier from "../assests/newfile/frontier.jpg";
import Hiro from "../assests/newfile/hiro.png";
import Itoken from "../assests/newfile/itoken.jpg";
import Kfinance from "../assests/newfile/kfinance.png";
import Kryptogo from "../assests/newfile/kryptogo.png";
import ItWallet from "../assests/newfile/ltwallet.jpg";
import IzWallet from "../assests/newfile/lzwallet.png";
import MaskNetwork from "../assests/newfile/masknetwork.png";
import Monarch from "../assests/newfile/monarch.png";
import Phantom from "../assests/newfile/phantom.png";
import Safemoon from "../assests/newfile/safemoon.png";
import Sepolia from "../assests/newfile/sepolia.svg";
import Sepoliaaa from "../assests/newfile/sepoliaa.jpg";
import Solana from "../assests/newfile/solana.png";
import SolFlare from "../assests/newfile/solflare.png";
import SparkPoint from "../assests/newfile/sparkpoint.jpg";
import Spot from "../assests/newfile/spot.png";
import Status from "../assests/newfile/status.png";
import TokenPocket from "../assests/newfile/tokenpocket.png";
import UvToken from "../assests/newfile/uvtoken.png";
import WalletConnet from "../assests/newfile/walletconnect.png";
import Xfun from "../assests/newfile/xfun.png";
import Xverse from "../assests/newfile/xverse.png";
import Zengo from "../assests/newfile/zengo.png";
import PerWallets from "./PerWallets";

const Wallets = () => {
  return (
    <div className="flex flex-col mx-8 mt-5 space-y-10 text-center align-middle">
      <div className="flex justify-center">
        <div className="grid  grid-cols-1 gap-4 mt-4 sm:grid-cols-2 md:grid-cols-4">
          <PerWallets
            myLink="#"
            src={Xverse}
            caption="Xverse"
            walletsName="Xverse Wallet"
            appName="Xverse"
          />
          <PerWallets
            myLink="#"
            src={Sepoliaaa}
            caption="Sepolia"
            walletsName="Sepolia Wallet"
            appName="sepolia"
          />
          <PerWallets
            myLink="#"
            src={Hiro}
            caption="Hiro"
            walletsName="Hiro Wallet"
            appName="Hiro"
          />
          <PerWallets
            myLink="#"
            src={Rainbow}
            caption="Rainbow"
            walletsName="Rainbow Wallet"
            appName="rainbow"
          />
          <PerWallets
            myLink="#"
            src={WalletConnet}
            caption="Walletconnect"
            walletsName="WalletConnect"
            appName="wallet-connect"
          />
          <PerWallets
            myLink="#"
            src={TrustWallet}
            caption="Trust Wallet"
            walletsName="Trust Wallet"
            appName="trust wallet"
          />
          <PerWallets
            myLink="#"
            src={Argent}
            caption="Argent"
            appName="argent"
            walletsName="Argent Wallet"
          />
          <PerWallets
            myLink="#"
            src={MetaMask}
            caption="MetaMask"
            appName="metmask"
            walletsName="MetaMask Wallet"
          />
          <PerWallets
            myLink="#"
            walletsName="Gnosis Safe Multisig"
            src={CriptoCom}
            appName="gnosis safe"
            caption="Gnosis Safe Multisig Wallet"
          />

          <PerWallets
            myLink="#"
            src={Pillar}
            caption="Pillar"
            appName="pillar"
            walletsName="Pillar Wallet"
          />
          <PerWallets
            myLink="#"
            src={ImToken}
            caption="imToken"
            appName="imtoken"
            walletsName="imToken Wallet"
          />
          <PerWallets
            myLink="#"
            src={Onto}
            caption="ONTO"
            appName="onto"
            walletsName="ONTO Wallet"
          />
          <PerWallets
            myLink="#"
            src={mathwallet}
            caption="MathWallet"
            appName="mathwallet"
            walletsName="MathWallet"
          />
          <PerWallets
            myLink="#"
            src={Bitpay}
            caption="BitPay"
            appName="bitpay"
            walletsName="BitPay"
          />
          <PerWallets
            myLink="#"
            src={LedgerLive}
            caption="Ledger Live"
            appName="ledger live"
            walletsName="Ledger Live Wallet"
          />
          <PerWallets
            myLink="#"
            src={Walleth}
            caption="Walleth"
            appName="walleth"
            walletsName="Walleth Wallet"
          />
          <PerWallets
            myLink="#"
            src={Authereum}
            caption="Authereum"
            appName="authereum"
            walletsName="Authereum Wallet"
          />
          <PerWallets
            myLink="#"
            src={Dharma}
            caption="Dharma"
            appName="dharma"
            walletsName="Dharma Wallet"
          />
          <PerWallets
            myLink="#"
            src={OneInch}
            caption="1inch Wallet"
            appName="1inch"
            walletsName="1inch Wallet"
          />
          <PerWallets
            myLink="#"
            src={Huobi}
            caption="Huobi"
            appName="huobi"
            walletsName="Huobi Wallet"
          />
          <PerWallets
            myLink="#"
            src={Eidor}
            caption="Eidoo"
            appName="eidoo"
            walletsName="Eidoo Wallet"
          />
          <PerWallets
            myLink="#"
            src={Mykey}
            caption="MYKEY"
            appName="mykey"
            walletsName="MYKEY Wallet"
          />
          <PerWallets
            myLink="#"
            src={Loopring}
            caption="Loopring Wallet"
            walletsName="Loopring Wallet"
            appName="loopring"
          />
          <PerWallets
            myLink="#"
            src={TrustVault}
            caption="TrustVault"
            appName="trustvault"
            walletsName="TrustVault Wallet"
          />
          <PerWallets
            myLink="#"
            src={Atomic}
            caption="Atomic"
            appName="atomic"
            walletsName="Atomic Wallet"
          />
          <PerWallets
            myLink="#"
            src={Coin98}
            caption="Coin98"
            appName="coin98"
            walletsName="Coin98 Wallet"
          />
          <PerWallets
            myLink="#"
            src={CoolWallet}
            caption="CoolWallet S"
            appName="coolwallet"
            walletsName="CoolWallets"
          />
          <PerWallets
            myLink="#"
            src={Alice}
            caption="Alice"
            appName="alice"
            walletsName="Alice Wallet"
          />
          <PerWallets
            myLink="#"
            src={Dcent}
            caption="D'CENT Wallet"
            appName="d'cent"
            walletsName="D'CENT Wallet"
          />
          <PerWallets
            myLink="#"
            src={Zelcore}
            caption="ZelCore"
            appName="zelcore"
            walletsName="ZelCore"
          />
          <PerWallets
            myLink="#"
            src={Nash}
            caption="Nash"
            appName="nash"
            walletsName="Nash Wallet"
          />
          <PerWallets
            myLink="#"
            src={Coinomi}
            caption="Coinomi"
            appName="coinomi"
            walletsName="Coinomi Wallet"
          />
          <PerWallets
            myLink="#"
            src={GridPlus}
            caption="GridPlus"
            appName="gridplus"
            walletsName="GridPlus"
          />
          <PerWallets
            myLink="#"
            src={Sepolia}
            caption="Arbitrum"
            walletsName="Arbitrum Wallet"
            appName="arbitrum"
          />
          <PerWallets
            myLink="#"
            src={Cybavo}
            caption="CYBAVO Wallet"
            appName="cybavo"
            walletsName="CYBAVO Wallet"
          />
          <PerWallets
            myLink="#"
            src={Tokenary}
            caption="Tokenary"
            appName="tokenary"
            walletsName="Tokenary Wallet"
          />
          <PerWallets
            myLink="#"
            src={Torus}
            caption="Torus"
            appName="torus"
            walletsName="Torus Wallet"
          />
          <PerWallets
            myLink="#"
            src={Spatium}
            caption="Spatium"
            appName="spatium"
            walletsName="Spatium Wallet"
          />
          <PerWallets
            myLink="#"
            src={SafePal}
            caption="SafePal"
            appName="safepal"
            walletsName="SafePal Wallet"
          />
          <PerWallets
            myLink="#"
            src={Infinito}
            caption="Infinito"
            appName="infinito"
            walletsName="Infinito"
          />
          <PerWallets
            myLink="#"
            src={WalletIo}
            caption="Wallet.io"
            appName="wallet.io"
            walletsName="Wallet.io"
          />
          <PerWallets
            myLink="#"
            src={Infinity}
            caption="Infinity Wallet"
            appName="infinity"
            walletsName="Infinity Wallet"
          />
          <PerWallets
            myLink="#"
            src={Ownbit}
            caption="Ownbit"
            appName="ownbit"
            walletsName="Ownbit Wallet"
          />
          <PerWallets
            myLink="#"
            src={EasyPocket}
            caption="SparkPoint"
            appName="sparkpoint"
            walletsName="SparkPoint Wallet"
          />
          <PerWallets
            myLink="#"
            src={ViaWallet}
            caption="ViaWallet"
            appName="viawallet"
            walletsName="ViaWallet Wallet"
          />
          <PerWallets
            myLink="#"
            src={BitKeep}
            caption="BitKeep"
            appName="bitkeep"
            walletsName="BitKeep Wallet"
          />
          <PerWallets
            myLink="#"
            src={Vision}
            caption="Vision"
            appName="vision"
            walletsName="Vision Wallet"
          />
          <PerWallets
            myLink="#"
            src={PeakDefi}
            caption="PEAKDEFI Wallet"
            appName="peakdefi"
            walletsName="PEAKDEFI Wallet"
          />
          <PerWallets
            myLink="#"
            src={Unstoppable}
            caption="Unstoppable Wallet"
            appName="unstoppable"
            walletsName="Unstoppable Wallet"
          />
          <PerWallets
            myLink="#"
            src={HaloDefi}
            caption="HaloDeFi Wallet"
            appName="halodefi"
            walletsName="HaloDefi Wallet"
          />
          <PerWallets
            myLink="#"
            src={Dok}
            caption="Dok Wallet"
            appName="dok"
            walletsName="Dok Wallet"
          />
          <PerWallets
            myLink="#"
            src={AtWallet}
            caption="AT.Wallet"
            appName="at wallet"
            walletsName="AT.Wallet"
          />
          <PerWallets
            myLink="#"
            src={Midas}
            caption="Midas Wallet"
            appName="midas"
            walletsName="Midas Wallet"
          />
          <PerWallets
            myLink="#"
            src={Ellipal}
            caption="Ellipal"
            appName="ellipal"
            walletsName="Ellipal Wallet"
          />
          <PerWallets
            myLink="#"
            src={KeyRing}
            caption="KEYRING PRO"
            appName="keyring pro"
            walletsName="KEYRING PRO Wallet"
          />
          <PerWallets
            myLink="#"
            src={Aktionariat}
            caption="AKTIONARIAT"
            appName="aktionariat"
            walletsName="AKTIONARIAT Wallet"
          />
          <PerWallets
            myLink="#"
            src={Talken}
            caption="Talken Wallet"
            appName="talken"
            walletsName="Talken Wallet"
          />
          <PerWallets
            myLink="#"
            src={XinfinXdc}
            caption="XinFin XDC Network"
            appName="xinfin xdc "
            walletsName="XinFin XDC NetWork Wallet"
          />
          <PerWallets
            myLink="#"
            src={Flare}
            caption="Flare Wallet"
            appName="flare"
            walletsName="Flare Wallet"
          />
          <PerWallets
            myLink="#"
            src={KyberSwap}
            caption="KyberSwap"
            appName="kyberswap"
            walletsName="KyberSwap Wallet"
          />
          <PerWallets
            myLink="#"
            src={Atoken}
            caption="AToken Wallet"
            appName="atoken"
            walletsName="AToken Wallet"
          />
          <PerWallets
            myLink="#"
            src={Tongue}
            caption="Tongue Wallet"
            appName="tongue"
            walletsName="Tongue Wallet"
          />
          <PerWallets
            myLink="#"
            src={RWallet}
            caption="RWallet"
            appName="rwwallet"
            walletsName="RWallet"
          />
          <PerWallets
            myLink="#"
            src={PlasmaPay}
            caption="PlasmaPay"
            appName="plasmapay"
            walletsName="PlasmaPay Wallet"
          />
          <PerWallets
            myLink="#"
            src={O3Wallet}
            caption="03Wallet"
            appName="03wallet"
            walletsName="03Wallet"
          />
          <PerWallets
            myLink="#"
            src={HashKey}
            caption="HashKey Me"
            appName="hashkey me"
            walletsName="HashKey Me Wallet"
          />
          <PerWallets
            myLink="#"
            src={Jade}
            caption="Jade Wallet"
            appName="jade"
            walletsName="Jade Wallet"
          />
          <PerWallets
            myLink="#"
            src={Guarda}
            caption="Guarda"
            appName="guarda"
            walletsName="Guarda Wallet"
          />
          <PerWallets
            myLink="#"
            src={Defiant}
            caption="Defiant"
            appName="defiant"
            walletsName="Defiant Wallet"
          />
          <PerWallets
            myLink="#"
            src={Trustee}
            caption="Trustee Wallet"
            appName="trustee"
            walletsName="Trustee Wallet"
          />
          <PerWallets
            myLink="#"
            src={AlphaWallet}
            caption="Alpha"
            walletsName="Alpha Wallet"
            appName="alpha"
          />
          <PerWallets
            myLink="#"
            src={BalletWallet}
            caption="Ballet"
            walletsName="Ballet Wallet"
            appName="ballet"
          />
          <PerWallets
            myLink="#"
            src={BeeWallet}
            caption="Bee"
            walletsName="Bee Wallet"
            appName="bee"
          />
          <PerWallets
            myLink="#"
            src={Bitski}
            caption="Bitski"
            walletsName="Bitski Wallet"
            appName="bitski"
          />
          <PerWallets
            myLink="#"
            src={Cosmotation}
            caption="Cosmotation"
            walletsName="Cosmotation Wallet"
            appName="cosmotation"
          />
          <PerWallets
            myLink="#"
            src={CryptnosApp}
            caption="CryptnosApp"
            walletsName="CryptosApp Wallet"
            appName="cryptosapp"
          />
          <PerWallets
            myLink="#"
            src={FilWallet}
            caption="Fil"
            walletsName="Fil Wallet"
            appName="fil"
          />
          <PerWallets
            myLink="#"
            src={Frontier}
            caption="Frontier"
            walletsName="Frontier Wallet"
            appName="frontier"
          />
          <PerWallets
            myLink="#"
            src={Itoken}
            caption="Itoken"
            walletsName="Itoken Wallet"
            appName="itoken"
          />
          <PerWallets
            myLink="#"
            src={Kfinance}
            caption="K Finance"
            walletsName="K Finance Wallet"
            appName="kfinance"
          />
          <PerWallets
            myLink="#"
            src={Kryptogo}
            caption="Krypto Go"
            walletsName="Krypto Go Wallet"
            appName="kryptogo"
          />
          <PerWallets
            myLink="#"
            src={ItWallet}
            caption="ItWallet"
            walletsName="IT Wallet"
            appName="it-wallet"
          />
          <PerWallets
            myLink="#"
            src={IzWallet}
            caption="IZ Wallet"
            walletsName="IZ Wallet"
            appName="iz-wallet"
          />
          <PerWallets
            myLink="#"
            src={MaskNetwork}
            caption="MaskNetwork"
            walletsName="MaskNetwork Wallet"
            appName="masknetwork"
          />
          <PerWallets
            myLink="#"
            src={Monarch}
            caption="Monarch"
            walletsName="Monarch Wallet"
            appName="monarch"
          />
          <PerWallets
            myLink="#"
            src={Phantom}
            caption="Phantom"
            walletsName="Phantom Wallet"
            appName="phantom"
          />
          <PerWallets
            myLink="#"
            src={Safemoon}
            caption="Safe Moon"
            walletsName="Safe Moon Wallet"
            appName="safemoon"
          />
          <PerWallets
            myLink="#"
            src={Solana}
            caption="Solana"
            walletsName="Solana Wallet"
            appName="solana"
          />
          <PerWallets
            myLink="#"
            src={SolFlare}
            caption="SolFlare"
            walletsName="SolFare Wallet"
            appName="solflare"
          />
          <PerWallets
            myLink="#"
            src={SparkPoint}
            caption="Sparkpoint"
            walletsName="Sparkpoint Wallet"
            appName="sparkpoint"
          />
          <PerWallets
            myLink="#"
            src={Spot}
            caption="Spot"
            walletsName="Spot Wallet"
            appName="spot"
          />
          <PerWallets
            myLink="#"
            src={Status}
            caption="Status"
            walletsName="Status Wallet"
            appName="status"
          />
          <PerWallets
            myLink="#"
            src={TokenPocket}
            caption="Token Pocket"
            walletsName="Token Pocket Wallet"
            appName="tokenpocket"
          />
          <PerWallets
            myLink="#"
            src={BridgeWallet}
            caption="Bridge Wallet"
            walletsName="Bridge Wallet"
            appName="bridge"
          />
          <PerWallets
            myLink="#"
            src={UvToken}
            caption="UvToken"
            walletsName="UvToken Wallet"
            appName="uvtoken"
          />
          <PerWallets
            myLink="#"
            src={Vision}
            caption="Vision"
            walletsName="Vission Wallet"
            appName="vision"
          />
          <PerWallets
            myLink="#"
            src={Xfun}
            caption="XFUN"
            walletsName="XFUN Wallet"
            appName="xfun"
          />
          <PerWallets
            myLink="#"
            src={Zengo}
            caption="Zengo"
            walletsName="Zengo Wallet"
            appName="zengo"
          />
          <PerWallets
            myLink="#"
            src={OtherApp}
            caption="Other"
            walletsName="Other Wallet"
            appName="other"
          />
        </div>
      </div>
    </div>
  );
};

export default Wallets;
